/* MT-021 homepage A/B/live split helpers (PREVIEW 2026-10-19). Deferred, every page.
   1. Cart attributes: writes hp_variant + hp_first_seen into the cart (/cart/update.js) when the cart lacks them, on
      every page load and after the theme's cart-update event, so the group lands on the order's note_attributes
      whatever page or visit the purchase happens on. If local storage lost the group (Safari's 7-day cap) but the
      cart still carries it, the cart's value is restored locally; if the two disagree the cart's first value wins.
   2. Homepage A/B behaviours: slider dots, the sticky buy bar that hides while the hero button is on screen, the phone
      number in the desktop header, and a how-it-works anchor. */
(function () {
  var M = window.MT021 || {}, g = M.group, d = document, H = d.documentElement;
  if (H.classList.contains('hpv-bot')) return;

  function rc(n) { var m = d.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  function store(v, first) {
    try { var e = new Date(Date.now() + 365 * 864e5).toUTCString();
      d.cookie = 'hpv=' + v + '; expires=' + e + '; path=/; SameSite=Lax; Secure';
      d.cookie = 'hpv_d=' + encodeURIComponent(first || '') + '; expires=' + e + '; path=/; SameSite=Lax; Secure'; } catch (e) {}
    try { localStorage.setItem('hpv', v); localStorage.setItem('hpv_d', first || ''); } catch (e) {}
    M.group = g = v; M.first = first || M.first; H.setAttribute('data-hpv-cart', v);
  }
  function json(u, o) { return fetch(u, o).then(function (r) { return r.json(); }); }
  var syncing = false;
  function syncCart() {
    if (syncing) return; syncing = true;
    json('/cart.js').then(function (c) {
      var a = c.attributes || {}, cv = a.hp_variant || '', cd = a.hp_first_seen || '';
      H.setAttribute('data-hpv-cart', cv || 'none');
      var forced = !!M.forced;                                        /* ?hpv=... review override (or reset): it wins */
      if (cv && !g) { store(cv, cd); return; }                       /* storage lost, cart remembers */
      if (!g) return;                                                 /* no homepage exposure yet: nothing to tag */
      if (cv && cv !== g && !forced) { store(cv, cd || M.first); return; }   /* cart's first group wins */
      if (cv === g && cd && !forced) return;                          /* already tagged */
      return json('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { hp_variant: g, hp_first_seen: M.first || '' } }) })
        .then(function (c2) { H.setAttribute('data-hpv-cart', ((c2 && c2.attributes) || {}).hp_variant || 'none'); });
    }).catch(function () {}).then(function () { syncing = false; });
  }
  setTimeout(syncCart, d.readyState === 'complete' ? 300 : 1500);
  window.addEventListener('load', function () { setTimeout(syncCart, 1200); });
  if (typeof subscribe === 'function') { try { subscribe('cart-update', function () { setTimeout(syncCart, 400); }); } catch (e) {} }
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCart(); });

  /* ------------------------------------------------------------ homepage A/B only */
  var root = d.querySelector('html.hpv-A .v4a.mt021-hp, html.hpv-B .v4b.mt021-hp');
  if (!root) return;
  var cta = root.querySelector('.v4a-hero .v4a-btn, .v4b-hero .v4b-btn'), st = root.querySelector('.v4a-sticky, .v4b-sticky');
  if (cta && st && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; st.style.transform = on ? '' : 'translateY(110%)'; d.documentElement.classList.toggle('mt021-bar-on', on); }, { threshold: 0.4 }).observe(cta);   /* the bar shows only once the hero button has scrolled past the top, as on the live page; on short phones it no longer sits over the headline on the first screen */   /* mt021-bar-on lifts the chat bubble only while the bar shows */
  }
  root.querySelectorAll('[data-for]').forEach(function (dots) {
    var t = d.querySelector(dots.getAttribute('data-for')); if (!t) return;
    var kids = [].slice.call(t.children); if (kids.length < 2) return;
    kids.forEach(function (k, i) { var s = d.createElement('i'); if (i === 0) s.className = 'on'; dots.appendChild(s); });
    t.addEventListener('scroll', function () {
      var c = t.scrollLeft + t.clientWidth / 2, best = 0;
      kids.forEach(function (k, i) { if (Math.abs(k.offsetLeft + k.offsetWidth / 2 - c) < Math.abs(kids[best].offsetLeft + kids[best].offsetWidth / 2 - c)) best = i; });
      [].forEach.call(dots.children, function (s, i) { s.className = i === best ? 'on' : ''; });
    }, { passive: true });
  });
  var phone = root.getAttribute('data-mt021-phone'), tel = root.getAttribute('data-mt021-tel');
  var icons = d.querySelector('.header__icons');
  if (phone && icons && !icons.querySelector('.mt021-phone')) {
    var a = d.createElement('a'); a.className = 'mt021-phone'; a.href = 'tel:' + tel; a.textContent = phone; icons.insertBefore(a, icons.firstChild);
  }
})();
/* Sticky bar reviews (Larry 14179): open the same Loox reviews panel as the desktop Reviews tab; fall back to the reviews on the page */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-mt021-reviews]'); if (!b) return;
  e.preventDefault();
  if (window.MGReviewsPopup && window.MGReviewsPopup.open()) return;   /* popup of the page's own reviews, page stays put (Larry 14208) */
  var t = document.getElementById('loox-floating-widget-btn');
  if (t) { t.click(); return; }
  var r = document.getElementById('looxReviews'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
/* Review stars -> popup (Larry 14208, Oct 20 2026): open the reviews that are already on this page in an
   overlay, without scrolling the visitor away from where they are in the page. The on-page Loox block is lifted
   into the overlay in place (no DOM move, so its frame does not reload) and a same-height placeholder keeps
   the page from shifting; closing puts everything back. */
window.MGReviewsPopup = window.MGReviewsPopup || (function () {
  function open() {
    var r = document.getElementById('looxReviews');
    if (!r || r.classList.contains('mg-rev-pop')) return !!r;
    var ph = document.createElement('div');
    ph.style.height = r.offsetHeight + 'px';
    r.parentNode.insertBefore(ph, r);
    var bd = document.createElement('div'); bd.className = 'mg-rev-backdrop';
    var x = document.createElement('button'); x.type = 'button'; x.className = 'mg-rev-close'; x.setAttribute('aria-label', 'Close reviews'); x.innerHTML = '&times;';
    document.body.appendChild(bd); document.body.appendChild(x);
    r.classList.add('mg-rev-pop'); r.scrollTop = 0;
    document.documentElement.classList.add('mg-rev-open');
    function esc(e) { if (e.key === 'Escape') close(); }
    function close() {
      r.classList.remove('mg-rev-pop'); document.documentElement.classList.remove('mg-rev-open');
      ph.remove(); bd.remove(); x.remove(); document.removeEventListener('keydown', esc);
    }
    bd.addEventListener('click', close); x.addEventListener('click', close); document.addEventListener('keydown', esc);
    return true;
  }
  return { open: open };
})();
/* Chat bubble clearance (Larry 14322): measure the bottom bar's real height on screen (it grows by the iPhone safe area in
   Chrome iOS and Safari) and keep the chat bubble 14 px above it, re-measured on scroll, resize and toolbar changes. */
(function () {
  var bar = document.querySelector(document.documentElement.classList.contains('hpv-B') ? '.v4b-sticky' : '.v4a-sticky'); if (!bar) return;   /* the group's own bar (both sections are in the page) */
  var H = document.documentElement, q = false;
  function set() {
    q = false;
    /* bar and bubble are both pinned to the bottom edge, so use the bar's own layout height (includes the safe-area padding);
       viewport maths drift while Chrome iOS slides its toolbar (Larry's video 14340) */
    var h = bar.offsetHeight; if (h > 0 && h < 200) H.style.setProperty('--mt021-bar-h', h + 'px');
  }
  function go() { if (!q) { q = true; requestAnimationFrame(set); } }
  ['scroll', 'resize', 'orientationchange'].forEach(function (e) { window.addEventListener(e, go, { passive: true }); });
  if (window.visualViewport) { window.visualViewport.addEventListener('resize', go); window.visualViewport.addEventListener('scroll', go); }
  set(); setTimeout(set, 800); setTimeout(set, 3000);
})();
